module.exports = __webpack_public_path__ + "static/media/2025_wolke.478ae022.png";